import React from 'react';
import PropTypes from 'prop-types';
import { buildPaginationItems } from '../../helpers';
import BlazeLink from '../../../BlazeLink';
import buildPaginationUrl from '../../helpers/build-pagination-url';
import { NEXT_STRING, PREVIOUS_STRING } from '../../../../constants';

const Classic = ({
  name,
  numberOfPages,
  currentPage,
  query,
  url,
  isLastPage,
  onClick,
  componentId
}) => {
  const pages = buildPaginationItems({
    name,
    numberOfPages,
    currentPage,
    query,
    url,
    onClick,
    componentId
  });
  const nextPage = currentPage + 1;
  const previousPage = currentPage - 1;
  const previousPageLink =
    currentPage > 1 ? buildPaginationUrl(name, previousPage, query, url, componentId) : null;
  const nextPageLink = !isLastPage
    ? buildPaginationUrl(name, nextPage, query, url, componentId)
    : null;

  return (
    <>
      {!!previousPageLink && (
        <BlazeLink
          href={previousPageLink}
          className="pagination_page-previous"
          onClick={onClick}
          shallow
          scroll={false}>
          {`${PREVIOUS_STRING} page`}
        </BlazeLink>
      )}
      {pages}
      {!!nextPageLink && (
        <BlazeLink
          href={nextPageLink}
          className="pagination_page-next"
          onClick={onClick}
          shallow
          scroll={false}>
          {`${NEXT_STRING} page`}
        </BlazeLink>
      )}
    </>
  );
};

Classic.propTypes = {
  componentId: PropTypes.string.isRequired,
  numberOfPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  query: PropTypes.object.isRequired,
  url: PropTypes.string.isRequired,
  isLastPage: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default Classic;
